import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import Tag from '../../models/Tag';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';

async function createTag(payload: Tag, auth: Authentication): Promise<void> {
  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new CreateTagFailure('Unauthorized', 'unauthorized');
  }

  try {
    await HttpClient.post('/tags', {
      name: payload.name,
      category: payload.category,
      id_domain: payload.idDomain,
      id_subscription: payload.idSubscription,
      prompt_instructions: payload.promptInstructions,
      color: payload.color,
    }, auth.token);
  } catch (e) {
    console.log('error: ', e);
    throw new CreateTagFailure();
  }
}

export class CreateTagFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default createTag;
